<template>
  <div>
    <div class="search-wrap">
      <el-input size="mini" style="width: 300px;" placeholder="请输入房产" v-model="where.house_name" clearable></el-input>
      <el-date-picker
        size="mini"
        v-model="where.start_end_time"
        unlink-panels
        type="daterange"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>

      <el-select v-model="where.use_name" placeholder="选择日志类型" clearable>
        <el-option
          v-for="item in ['应收拆分','应收合并']"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>

      <el-button size="mini" type="primary" @click="search()" style="margin-right: 5px;" icon="el-icon-search">查询</el-button>
      <div style="width: 30px;display: inline-block;"></div>

      <el-button type="primary" size="mini" icon="el-icon-scissors" v-if="multipleSelection.length" @click="rollback()">恢复</el-button>

    </div>

    <div class="table-wrap">
      <el-table v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="id" label="ID" align="center" width="80"></el-table-column>
        <el-table-column prop="house_name" label="房产" align="center" width="250"></el-table-column>
        <el-table-column prop="use_name" label="变更类型" align="center" width="200"></el-table-column>
        <el-table-column prop="order_id" label="变更前ID" align="center" width="100"></el-table-column>
        <el-table-column prop="new_order_ids" label="变更前后ID" align="center" width="150"></el-table-column>
        <el-table-column prop="admin_name" label="操作人" align="center" width="100"></el-table-column>
        <el-table-column prop="create_time" label="操作时间" align="center" width="100"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="primary" size="mini" @click="showInfo(scope.row)">详情</el-button>
            <el-button type="primary" size="mini" @click="rollback(scope.row)">恢复</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination-wrap">
      <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
    </div>

    <el-dialog title="详情" :visible.sync="dialogVisible" :close-on-click-modal="false" width="800px">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-descriptions :column="2" border size="mini">
          <el-descriptions-item v-for="(item,index) in info_keys" :key="index" :label="item" :prop="item">
            {{info_obj[item]}}
          </el-descriptions-item>
        </el-descriptions>
      </div>

    </el-dialog>

  </div>
</template>

<script>
export default {
  name: "OrderLog",
  data(){
    return{
      loading: false,
      dialogVisible:false,
      where:{
        name:"",
        house_name:"",
        start_end_time:"",
        use_name:"应收合并"
      },
      pageData:{
        list:[],
        total:0,
        pageSize:15,
        page:1
      },
      multipleSelection:[],
      order_bill_type_list:[],
      house_charge_item_list:[],
      house_charge_list:[],

      info_keys:[],
      info_obj:{}
    }
  },
  watch:{
    info_obj:{
      deep:true,
      immediate:true,
      handler(n){
        this.info_keys=Object.keys(n);
      }
    }
  },
  methods:{
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      let where=reObject(this.where);
      where.project_house_id=undefined;
      ERP.getRequest({
        url:"admin/OrderLog/getList",
        data:{
          where:JSON.stringify(where),
          page: this.pageData.page,
          page_size: this.pageData.pageSize
        }
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
        that.multipleSelection=[]
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    nodeClick(data){
      this.where.house_name=data.tree.map(ret => {
        return ret.name
      }).join('->');
      this.$forceUpdate()
    },
    getHouseChargeItemList(){//费项类型表
      var that=this;
      let where={};
      ERP.getRequest({
        url:"admin/HouseChargeitemName/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_item_list=ret.data.list;
        }
      })
    },
    getHouseChargeList(){//费项表
      var that=this;
      let where={};
      this.where.project_house_id&&(where.pindex_id=this.where.project_house_id);
      this.where.xsc_ChargeItemID_id&&(where.chargeItem_name_id=this.where.xsc_ChargeItemID_id);
      ERP.getRequest({
        url:"admin/HouseCharge/getList",
        data:{
          where:JSON.stringify(where),
          page: 1,
          page_size: 200
        }
      },ret=>{
        if(ret.code){
          that.house_charge_list=ret.data.list;
        }
      })
    },
    showInfo(data){
      if(data.old_order_context){
        this.info_obj=JSON.parse(data.old_order_context)
      }else {
        this.info_obj=data;
      }
      this.dialogVisible=true;
    },
    rollback(data=null){
      var that=this;
      this.$confirm('是否确定恢复数据继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        if(data){
          this.multipleSelection=[];
          this.multipleSelection.push(data);
        }
        let ids=this.multipleSelection.map(ret=>{ return ret.id })
        if(ids.length){
          ERP.postRequest({
            url:"admin/OrderLog/rollback",
            data:{
              ids:ids.join(',')
            }
          },ret=>{
            if(ret.code){
              that.multipleSelection=[];
              that.getList();
              that.$message.success(ret.msg||'恢复成功');
            }else {
              that.$message.error(ret.msg||'恢复异常')
            }
          })
        }else {
          that.$message.error('选择日志')
        }

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消恢复'
        });
      });
    }
  }
}
function reObject(item){
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
.el-button--primary, .el-button--danger ,.el-button--success,.el-button--warning{
  color: #fff;
}


.check-work-body {
  padding: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}

.table-wrap {
  margin-top: 5px;
  //height: calc(70vh) !important;
  //overflow: auto !important;
}

.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td, th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}


.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 450px );
  //overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/OrderLog.vue